<template>
  <div class="entry-main-wrapper">
    <DataLoader :is_on="fetching" />
    <div class="entry-wrapper">
      <div class="entry-header">
        <div class="entry-header-left">
          <div class="entry-icon">
            <img src="@/assets/img/novi_predmet.svg" />
          </div>
          <div class="entry-title">{{ title_edit_new }}</div>
        </div>
        <div class="entry-header-right">
          <a @click="goBack()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
        </div>
      </div>
      <!-- end new case header -->
      <div class="main-entry-form-wrapper">
        <!-- *** BROJ PREDMETA **** -->
        <div class="form-autocomplete-add-wrapper case-num three-row-elements" v-show="!inhouseLimit">
          <div class="form-input-wrapper">
            <label class="form-label" for="sortYear">
              <span>{{ $t('forms.case.case_year') }}</span
              ><span>*</span>
            </label>
            <input
              id="sortYear"
              :class="['form-input', invalid_elements.broj_predmeta?'invalid':'']"
              type="number"
              name="sortYear"
              v-model="unos_predmeta.sort_year"
              v-bind:disabled="isNumberEditDisabled"
              required="required"
            />
          </div>
          <!-- <div class="form-input-wrapper">
            <label class="form-label" for="caseType">
              <span>Tip predmeta</span>
            </label>
            <div class="input-quick-select-parent input-select-main-parent">
              <select class="input-quick-select input-select-main" name="caseType" v-model="unos_predmeta.case_type" id="caseType">
                <option v-for="single_type in all_case_type" :key="single_type.id" :value="single_type.id" >{{single_type.name}}</option>
              </select>
            </div>
          </div> -->
          <div class="form-input-wrapper">
            <label class="form-label" for="sortNo">
              <span>{{ $t('forms.case.ordinal') }}</span
              ><span>*</span>
            </label>
            <input
              id="sortNo"
              :class="['form-input', invalid_elements.broj_predmeta?'invalid':'']"
              type="number"
              name="sortNo"
              v-model="unos_predmeta.sort_no"
              required="required"
              v-bind:disabled="isNumberEditDisabled"
              min="0"
            />
          </div>
          <div class="form-input-wrapper" v-show="!inhouseLimit">
          <label class="form-label" for="sortYear">
            <span>{{ $t('forms.case.case_number') }}</span>
          </label>
          <input
            id="broj-predmeta"
            :class="['form-input']"
            ref="brojPredmeta"
            type="text"
            v-model="unos_predmeta.broj_predmeta"

            required="required"
            disabled="disabled"
          />
        </div>
        </div>
        <!-- *** STRANKA **** -->
        <div class="form-autocomplete-add-wrapper" v-show="!inhouseLimit">
          <form-autocomplete :invalid="invalid_elements.stranka" type="Stranka" :label="$t('forms.case.party_lbl')" id="stranka"
            ref="stranka" :start="unos_predmeta.vezane_osobe.stranke.results_final"
            :placeholder="$t('forms.case.party_plh')" :items="all_fiz_prav" :statusi="statusi.stranka" :st_ID="'25'">
          </form-autocomplete>
          <button-person-quick type="Stranka" :statusi="statusi.stranka" ref="quickStranka"
            :postojece_fiz_prav="all_fiz_prav_copy" @addToAutocomplete="addToAutocomplete"></button-person-quick>
        </div>
        <!-- *** PROTUSTRANKA **** -->
        <div class="form-autocomplete-add-wrapper" v-show="!inhouseLimit">
          <form-autocomplete :invalid="invalid_elements.protustranka" :label="$t('forms.case.counterparty_lbl')" type="Protustranka" id="protustranka"
            ref="protustranka" :placeholder="$t('forms.case.counterparty_plh')" :items="all_fiz_prav"
            :statusi="statusi.protustranka" :start="unos_predmeta.vezane_osobe.protustranke.results_final"
            :st_ID="'22'"></form-autocomplete>
          <button-person-quick type="Protustranka" :statusi="statusi.protustranka" ref="quickProtustranka"
            :postojece_fiz_prav="all_fiz_prav_copy" @addToAutocomplete="addToAutocomplete"></button-person-quick>
        </div>
        <div class="form-autocomplete-add-wrapper" v-show="!inhouseLimit">
          <form-autocomplete type="Drugi_sudionici" :label="$t('forms.case.rest_lbl')" id="Drugi_sudionici" ref="drugi_sudionici"
            :placeholder="$t('forms.case.rest_plh')" :items="all_fiz_prav" :statusi="statusi.stranka" :st_ID="'30'">
          </form-autocomplete>
          <button-person-quick type="Drugi_sudionici" :statusi="statusi.stranka" ref="quickDrugiSudionici"
            :postojece_fiz_prav="all_fiz_prav_copy" @addToAutocomplete="addToAutocomplete"></button-person-quick>
        </div>
        <!-- *** DIVIDER **** -->
        <div class="form-divider" v-show="!inhouseLimit"></div>
        <!-- *** IME PREDMETA **** -->
        <form-input :invalid="invalid_elements.ime_predmeta" :class="[inhouseLimit ? 'disabled' : '']" :label="$t('forms.case.case_name')" id="ime-predmeta" ref="imePredmeta"
          required="required" :base="unos_predmeta.ime_predmeta" :is_edit="is_edit"></form-input>
        <!-- *** OPIS PREDMETA **** -->
        <form-textarea :label="$t('forms.case.description')" id="opis-predmeta" ref="opisPredmeta" :base="unos_predmeta.opis_predmeta">
        </form-textarea>
        <!-- *** ČLANOVI TIMA **** -->
        <div  :class="['clanovi-tima-wrapper', is_permission_inside('case.spis.edit', false) ? 'disabled' : '']">
          <div class="form-autocomplete-add-wrapper">
            <form-autocomplete :invalid="invalid_elements.clan_tima" :label="$t('forms.case.team_memb_lbl')" type="Član_tima"
              id="clan-tima" ref="clanTima" :placeholder="$t('forms.case.team_memb_plh')" :items="tim" :statusi="statusi.leg_tim"
              :st_ID="'1'" :start="unos_predmeta.vezane_osobe.leg_tim.results_final"></form-autocomplete>
          </div>
          <div class="button-assign-wrapper">
            <div class="button-default button-create" @click="assignToMe">{{$t('forms.case.to_me')}}</div>
          </div>
        </div>
        <!-- *** DIVIDER **** -->
        <div class="form-divider"></div>
        <!-- *** NADLEŽNO TIJELO **** -->
        <div class="form-autocomplete-add-wrapper" v-show="!inhouseLimit">
          <form-autocomplete-single v-if="!is_edit" :label="$t('forms.case.nadlezna_lbl')" type="Nadležna_tijela"
            id="nadlezna-tijela" ref="nadleznaTijela" :placeholder="$t('forms.case.nadlezna_plh')" :items="all_institucije"
            @addedNadlezno="removeFromQuick"></form-autocomplete-single>
          <button-person-quick v-if="!is_edit" type="Nadležno_tijelo" ref="quickNadleznaTijela"
            :postojeca_nadlezna="all_institucije_copy" @addToAutocomplete="addToAutocomplete"
            @removeExisting="removeExisting"></button-person-quick>
        </div>
        <!-- *** DRUGI SUDIONICI **** -->
        <div class="form-autocomplete-add-wrapper" v-show="!inhouseLimit">
          <form-autocomplete v-if="!is_edit" :label="$t('forms.case.osobe_post_lbl')" type="pravno_tijelo" id="pravno-tijelo"
            ref="pravnoTijelo" :placeholder="$t('forms.case.osobe_post_plh')" :items="legal_bodies"
            :statusi="statusi.leg_body" :st_ID="'7'"></form-autocomplete>
          <button-person-quick v-if="!is_edit" type="Pravno_tijelo" :statusi="statusi.leg_body" ref="quickPravnoTijelo"
            :postojeci_sudionici="legal_bodies_copy" @addToAutocomplete="addToAutocomplete"></button-person-quick>
        </div>
        <!-- *** SUDSKI BROJ *** -->
        <form-input v-show="!is_edit" :label="$t('forms.case.posl_broj_lbl')" id="sudski-broj" ref="sudskiBroj"
          :base="unos_predmeta.sudski_broj" ></form-input>
        <!-- *** VRSTA POSTUPKA **** -->
        <form-drop-down v-show="!is_edit" :label="$t('forms.case.vrsta_post_lbl')" id="vrsta-postupka" ref="vrstaPostupka"
          :dropImport="postupak" :base="unos_predmeta.vrsta_postupka"></form-drop-down>
        <!-- FAZA -->
        <form-drop-down :label="$t('forms.case.faze_lbl')" id="faza-predmeta" ref="fazaPredmeta" :dropImport="faze"
          :base="unos_predmeta.faza" v-show="!inhouseLimit"></form-drop-down>
        <!-- *** VPS **** -->
        <!-- <div class="form-autocomplete-add-wrapper">
          <form-input
          :invalid="invalid_elements.VPS"
          label="Vrijednost predmeta"
          id="VPS"
          ref="VPS"
          :base="unos_predmeta.VPS"
          class="form-input-currency"
          ></form-input>
          <div class="input-currency-element">
            <select name="valuta" id="valuta" ref="valuta" class="input-quick-select-dropdown input-select-main">
              <option v-for="(valuta, k) in valute" :key="k" :value="valuta.uid">{{valuta.short_name}}</option>
            </select>
          </div>
        </div> -->
        <form-currency-input :dropImport="valute" v-show="!inhouseLimit" :label="$t('forms.case.vrijed_lbl')" :invalid="invalid_elements.VPS"
          ref="valuta" :baseInput="unos_predmeta.VPS.vrijednost" :baseDropDown="unos_predmeta.VPS.valuta">
        </form-currency-input>
        <div class="form-input-wrapper" v-show="!inhouseLimit">
          <label class="form-label" for="datum">
            <span>{{$t('forms.case.date_created')}}</span>
          </label>
          <input
            :class="['form-input', 'date-input']"
            type="date"
            id="datum"
            ref="datumKreiranja"
            name="datum-pocekta"
            v-model="unos_predmeta.datum_kreiranja"
          />
        </div>
        <div v-if="archived_predmet" class="form-input-wrapper">
          <label class="form-label" for="archived">
            <span>{{$t('forms.case.date_archived')}}</span>
          </label>
          <input
            :class="['form-input', 'date-input']"
            type="date"
            id="archived"
            ref="datumArhiviranja"
            name="datum-pocekta"
            v-model="unos_predmeta.datum_arhiviranja"
          />
        </div>
        <div v-if="destroyed_predmet" class="form-input-wrapper">
          <label class="form-label" for="destroyed">
            <span>{{$t('forms.case.date_destroyed')}}</span>
          </label>
          <input
            :class="['form-input', 'date-input']"
            type="date"
            id="destroyed"
            ref="datumUnistavanja"
            name="datum-pocekta"
            v-model="unos_predmeta.datum_unistavanja"
          />
        </div>
        <!-- <form-drop-down
          label="Valuta"
          id="valuta"
          ref="valuta"
          :dropImport="postupak"
          :base="unos_predmeta.vrsta_postupka"
        ></form-drop-down> -->
        <InvalidElementsList v-if="errors.length != 0" :error_list="errors" />
        <!-- *** KREIRAJ BUTTON **** -->
        <div :class="{'fixed-to-bottom single':is_edit}">
            <div class="button-create-wrapper create-case-button">
              <div :class="{'disabled':is_waiting_on_insert}"
                class="button-default button-create" @click="!is_waiting_on_insert ? sequence_start() : ''">
                {{ create_edit_button }}
              </div>
            </div>
        </div>
        <div v-if="is_edit && !destroyed_predmet" class="button-arhiviraj-wrapper" v-show="!inhouseLimit">
          <div :class="['button-arhiviraj', archived_predmet && !destroyed_predmet ? 'green' : 'danger']"
            @click="archive_popup = true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 18" fill="none">
              <path
                d="M3.61461 3.63236C4.92813 2.31432 6.74326 1.5 8.75 1.5C12.7541 1.5 16 4.74594 16 8.75C16 12.7541 12.7541 16 8.75 16C4.74594 16 1.5 12.7541 1.5 8.75C1.5 8.33579 1.16421 8 0.75 8C0.335786 8 0 8.33579 0 8.75C0 13.5825 3.91751 17.5 8.75 17.5C13.5825 17.5 17.5 13.5825 17.5 8.75C17.5 3.91751 13.5825 0 8.75 0C6.32851 0 4.13558 0.984622 2.55213 2.57352C2.52668 2.59906 2.50345 2.62597 2.48245 2.65401L1.22488 1.39645C1.08769 1.25926 0.883533 1.21382 0.701112 1.27986C0.518691 1.34591 0.390942 1.51152 0.373378 1.70473L0.0198239 5.59382C0.00638932 5.7416 0.0592897 5.88771 0.164217 5.99264C0.269145 6.09757 0.415258 6.15047 0.563038 6.13703L4.45213 5.78348C4.64534 5.76591 4.81095 5.63817 4.87699 5.45575C4.94304 5.27332 4.8976 5.06916 4.76041 4.93198L3.5323 3.70386C3.56101 3.68235 3.58854 3.65852 3.61461 3.63236Z"
                fill="#FD4087" />
              <path
                d="M9.5 3.75C9.5 3.33579 9.16421 3 8.75 3C8.33579 3 8 3.33579 8 3.75V8.75C8 9.00859 8.13321 9.24895 8.3525 9.386L11.3525 11.261C11.7038 11.4805 12.1665 11.3738 12.386 11.0225C12.6055 10.6712 12.4988 10.2085 12.1475 9.989L9.5 8.33431V3.75Z"
                fill="#FD4087" />
            </svg>
            <span>{{ archive_button_text }}</span>
          </div>
          <div v-if="archived_predmet" :class="['button-arhiviraj', 'danger']" @click="destroy_popup = true">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 14 18" fill="none">
              <path
                d="M5.19355 0C4.81942 0 4.51613 0.298571 4.51613 0.666877V1.33375H0.677419C0.303291 1.33375 0 1.63232 0 2.00063C0 2.36894 0.303291 2.66751 0.677419 2.66751H13.3226C13.6967 2.66751 14 2.36894 14 2.00063C14 1.63232 13.6967 1.33375 13.3226 1.33375H9.48387V0.666877C9.48387 0.298571 9.18058 0 8.80645 0H5.19355Z"
                fill="#FD4087" />
              <path
                d="M7.95802 11.3369L9.28546 12.6437C9.55001 12.9041 9.55001 13.3264 9.28546 13.5868C9.02091 13.8472 8.59199 13.8472 8.32744 13.5868L7.00001 12.28L5.67256 13.5868C5.40801 13.8472 4.9791 13.8472 4.71455 13.5868C4.45 13.3264 4.45 12.9041 4.71455 12.6437L6.04199 11.3369L4.71454 10.0301C4.44999 9.76968 4.44999 9.34744 4.71454 9.08701C4.97909 8.82658 5.40801 8.82658 5.67256 9.08701L7.00001 10.3938L8.32745 9.08702C8.592 8.82658 9.02092 8.82658 9.28547 9.08702C9.55002 9.34745 9.55002 9.76969 9.28547 10.0301L7.95802 11.3369Z"
                fill="#FD4087" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M1.5729 5.03908C1.61102 4.70135 1.901 4.44585 2.24618 4.44585H11.7538C12.099 4.44585 12.389 4.70135 12.4271 5.03908L12.6079 6.64078C12.9356 9.5442 12.9356 12.4744 12.6079 15.3779L12.5901 15.5355C12.46 16.688 11.5527 17.607 10.3861 17.7678C8.13966 18.0774 5.86033 18.0774 3.61388 17.7678C2.44733 17.607 1.54 16.688 1.40992 15.5355L1.39212 15.3779C1.06442 12.4744 1.06442 9.5442 1.39212 6.64078L1.5729 5.03908ZM2.8525 5.7796L2.73867 6.78807C2.42202 9.5936 2.42202 12.425 2.73867 15.2306L2.75647 15.3882C2.81816 15.9348 3.24847 16.3707 3.80172 16.4469C5.92356 16.7394 8.07643 16.7394 10.1983 16.4469C10.7515 16.3707 11.1818 15.9348 11.2435 15.3882L11.2613 15.2306C11.578 12.425 11.578 9.5936 11.2613 6.78807L11.1475 5.7796H2.8525Z"
                fill="#FD4087" />
            </svg>
            <span>{{$t('forms.case.show_destroyed')}}</span>
          </div>
        </div>
        <div v-if="destroyed_predmet" class="button-arhiviraj-wrapper">
          <div :class="['button-arhiviraj', 'destroyed']">
            <span>{{$t('forms.case.case_destroyed')}}</span>
          </div>
        </div>
    </div>
      <v-dialog v-model="archive_popup" width="564px">
        <v-card color="universal-vcard">
          <div :class="['universal-vdialog-title', 'archive-title']">
            {{ popup_text }}
          </div>
          <v-menu v-if="!archived_predmet" ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :label="$t('forms.case.popup_plh')" v-model="dateText" readonly append-icon="mdi-calendar" v-bind="attrs"
                @click="menu1 = !menu1" v-on="on" class="case-date-picker archive-date-picker"></v-text-field>
            </template>
            <v-date-picker locale="hr" :first-day-of-week="1" v-model="unos_predmeta.datum_arhiviranja" no-title></v-date-picker>
          </v-menu>
          <div class="vdialog-buttons-wrapper wrapper-three-buttons">
            <div class="universal-vdialog-button vbutton-secondary" @click="archive_popup = false;"> {{ $t("repetitive.cancel") }} </div>
            <div class="universal-vdialog-button vbutton-primary" @click="archiveCase()"> {{ popup_button_text }} </div>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="destroy_popup" width="564px">
        <v-card color="universal-vcard">
          <div :class="['universal-vdialog-title', 'archive-title']">
            {{$t('forms.case.case_destroy_title')}}
          </div>
          <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateTextDestroyed" readonly :label="$t('forms.case.popup_plh2')" append-icon="mdi-calendar" v-bind="attrs"
                @click="menu2 = !menu2" v-on="on" class="case-date-picker archive-date-picker"></v-text-field>
            </template>
            <v-date-picker locale="hr" :first-day-of-week="1" v-model="unos_predmeta.datum_unistavanja" no-title></v-date-picker>
          </v-menu>
          <div :class="['universal-vdialog-title', 'archive-title']" style="color:red;padding-top:1rem;padding-bottom:1rem;">{{$t('forms.case.irrevesible')}}</div>
          <div class="vdialog-buttons-wrapper wrapper-three-buttons">
            <div class="universal-vdialog-button vbutton-secondary" @click="destroy_popup = false"> {{ $t("repetitive.cancel") }} </div>
            <div class="universal-vdialog-button vbutton-primary" @click="destroyCase()"> Uništi </div>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="postojeca_stranka_protustranka" width="564px">
        <v-card color="universal-vcard">
          <div class="universal-vdialog-title">
            {{ postojeci_dialog_text }}
          </div>
          <div class="vdialog-buttons-wrapper wrapper-three-buttons">
            <div class="universal-vdialog-button vbutton-secondary" @click="postojeca_stranka_protustranka = false">
              {{ $t("repetitive.cancel") }} </div>
            <div class="universal-vdialog-button vbutton-primary" @click="addPerson"> Dodaj </div>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="warning_unsaved" width="564px">
        <v-card color="universal-vcard">
            <div class="universal-vdialog-title">
                {{ $t('forms.unsaved_changes') }}
            </div>
            <div class="vdialog-buttons-wrapper">
            <div class="universal-vdialog-button vbutton-secondary" @click="warning_unsaved = false;"> {{ $t("repetitive.cancel") }} </div>
            <div class="universal-vdialog-button vbutton-primary" @click="continueGoBack()"> {{ $t("repetitive.discard") }} </div>
            </div>
        </v-card>
      </v-dialog>
      <!-- end main entry form wrapper -->
      <!-- <br /><br />
      <div><b>ROOT podaci:</b></div>
      <div><b>Broj predmeta: </b> {{ unos_predmeta.broj_predmeta }}</div>
      <div><b>Sudski broj: </b> {{ unos_predmeta.sudski_broj }}</div>
      <div><b>Ime predmeta: </b> {{ unos_predmeta.ime_predmeta }}</div>
      <div><b>Opis predmeta: </b> {{ unos_predmeta.opis_predmeta }}</div>
      <div><b>Vrsta postupka: </b> {{ unos_predmeta.vrsta_postupka }}</div>
      <div>
        <b>Nadležno tijelo: </b>
        {{ unos_predmeta.nadlezno_tijelo.results_final }}
      </div>
      <div>
        <b>Vezane osobe -> leg_tim: </b>
        {{ unos_predmeta.vezane_osobe.leg_tim.results_final }}
      </div>
      <div>
        <b>Vezane osobe -> stranke: </b>
        {{ unos_predmeta.vezane_osobe.stranke.results_final }}
      </div>
      <div>
        <b>Vezane osobe -> quickStranke: </b>
        {{ unos_predmeta.vezane_osobe.quickStranke.add_stranka }}
      </div>
      <div>
        <b>Vezane osobe -> protustranke: </b>
        {{ unos_predmeta.vezane_osobe.protustranke.results_final }}
      </div>
      <div>
        <b>Vezane osobe -> quickProtustranke: </b>
        {{ unos_predmeta.vezane_osobe.quickProtustranke.add_protustranka }}
      </div>
      <div>
        <b>Vezane osobe -> quickNadleznaTijela: </b>
        {{ unos_predmeta.vezane_osobe.quickNadleznaTijela.add_nadlezno_tijelo }}
      </div>
      <div><b>VPS: </b> {{ unos_predmeta.VPS }}</div>
      <br /><br /> -->
    </div>
    <!-- end new case wrapper -->
  </div>
  <!-- end new case main wrapper -->
</template>


<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import formAutocompleteSingle from "@/components/formElements/formAutocompleteSingle.vue";
import buttonPersonQuick from "@/components/formElements/buttonPersonQuick.vue";
import formCurrencyInput from "@/components/formElements/formCurrencyInput.vue"
import InvalidElementsList from "@/components/generalComponents/InvalidElementsList.vue";
import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
import predmet from "@/apiCallers/promise_handler_db/predmeti";
import statusi from "@/apiCallers/promise_handler_db/statusi";
import predmeti from "@/apiCallers/promise_handler_db/predmeti";
import financije from "@/apiCallers/promise_handler_db/financial";
import institucije from "@/apiCallers/promise_handler_db/institucije";
import financial from "@/apiCallers/promise_handler_db/financial";
import auth from "@/services/auth";
import DataLoader from '@/components/generalComponents/DataLoader';
import { clearCaseData } from "@/router/case/handler"

import permissioner from "@/services/permissioner.js"

import moment from 'moment';
import $ from "jquery";
import gsap from "gsap";

export default {
  data() {
    return {
      //
      title_edit_new: this.$t('forms.case.title_edit_new1'),
      is_edit: false,
      route_query: undefined,
      create_edit_button:  this.$t('forms.case.create_edit_button1'),
      //
      is_waiting_on_insert: false,
      accessToken: "",
      stranke: [],
      all_case_type : [],
      all_fiz_prav: [],
      all_fiz_prav_copy: [],
      all_institucije: [],
      all_institucije_copy: [],
      prijedlog_br_predmet: "",
      popis_broja_predmeta: [],
      protustranke: [],
      tim: [],
      faze: [],
      statusi: {
        stranka: [],
        protustranka: [],
        leg_tim: [],
        leg_body: [],
      },
      legal_bodies: [],
      legal_bodies_copy: [],
      postupak: [],
      valute: [],
      predmet_all: null,
      unos_predmeta: {
        sort_year : 1,
        sort_no : 1,
        case_type:1,
        broj_predmeta: "",
        ime_predmeta: "",
        opis_predmeta: null,
        vrsta_postupka: 1,
        sudski_broj: null,
        nadlezno_tijelo: "",
        VPS: {
          vrijednost: "",
          valuta: 1,
        },
        faza: 1,
        vezane_osobe: {
          leg_tim: [],
          stranke: [],
          quickStranke: [],
          protustranke: [],
          quickProtustranke: [],
          quickNadleznaTijela: [],
          drugi_sudionici: [],
          quickPravnaTijela: [],
          quickDrugiSudionici: [],
          leg_bodies: [],
        },
        datum_kreiranja:'',
        datum_arhiviranja:'',
        datum_unistavanja:'',
      },
      errors: [],
      invalid_elements: {
        // sort_year : false,
        // sort_no : false,
        broj_predmeta: false,
        stranka: false,
        protustranka: false,
        ime_predmeta: false,
        clan_tima: false,
        VPS: false,
      },
      fetching: true,
      archived_predmet: false,
      destroyed_predmet: false,
      archive_button_text:  this.$t('forms.case.archive_button_text'),
      popup_button_text:  this.$t('forms.case.popup_button_text'),
      popup_text: this.$t('forms.case.popup_text'),
      archive_popup: false,
      destroy_popup: false,
      postojeca_stranka_protustranka: false,
      postojeci_dialog_text: '',
      temp_osoba: null,
      menu1:false,
      menu2:false,
      temp_archive_date:"",
      temp_destroy_date:"",
      warning_unsaved:false,

      isNumberEditDisabled : false
    };
  },
  watch:{
    archive_popup:function(){
      this.temp_archive_date = this.unos_predmeta.datum_arhiviranja;
      if (this.archive_popup && this.unos_predmeta.datum_arhiviranja == "") {
        this.unos_predmeta.datum_arhiviranja = moment(Date.now()).format("yyyy-MM-DD");
      }
      else{
        this.unos_predmeta.datum_arhiviranja = this.temp_archive_date;
      }
    },
    destroy_popup:function(){
      this.temp_destroy_date = this.unos_predmeta.datum_unistavanja;
      if (this.destroy_popup && this.unos_predmeta.datum_unistavanja == "") {
        this.unos_predmeta.datum_unistavanja = moment(Date.now()).format("yyyy-MM-DD");
      }
      else{
        this.unos_predmeta.datum_unistavanja = this.temp_destroy_date;
      }
    },
    "unos_predmeta.sort_year":function(){
      this.unos_predmeta.broj_predmeta = `${this.unos_predmeta.sort_year}${this.get_case_type()}${this.unos_predmeta.sort_no}`
    },
    "unos_predmeta.case_type":function(){
      this.unos_predmeta.broj_predmeta = `${this.unos_predmeta.sort_year}${this.get_case_type()}${this.unos_predmeta.sort_no}`
    },
    "unos_predmeta.sort_no":function(){
      this.unos_predmeta.broj_predmeta = `${this.unos_predmeta.sort_year}${this.get_case_type()}${this.unos_predmeta.sort_no}`
    }
  },
  methods: {
    /**
     * Warns user if there are unsaved changes
     * or continues rerouting to previous view
     */
     goBack() {
      if (this.is_edit) {
        this.warning_unsaved = true;
      }
      else{
        this.continueGoBack();
      }
    },
    continueGoBack() {
      this.$router.go(-1);
    },
    get_case_type : function()
    {
      if(this.unos_predmeta.case_type == 1)
      {
        return "-";
      }
      else{
        return "-" + this.all_case_type[this.unos_predmeta.case_type-1].shortened +"-"
      }
    },  
    
    is_permission_inside(wanted_permission, assistent_check = true) {
      if(this.is_edit)
      {
        return (!permissioner.check_case_permsision(wanted_permission, assistent_check))
      }else{
        return false;
      }
      
    },
    async destroyCase() {
      this.fetching = true;
      await clearCaseData();
      await predmeti.unistiPredmet(this.route_query,this.unos_predmeta.datum_unistavanja).then((resp) => {
        this.fetching = false;
        this.destroy_popup = false,
          this.$router.push('/archived-case/' + this.route_query);
      })
    },
    async archiveCase() {
      this.fetching = true;
      await clearCaseData();
      if (this.archived_predmet) {
        await predmeti.aktivirajPredmet(this.route_query).then((resp) => {
          this.fetching = false;
          this.archive_popup = false,
            this.$router.push('/case/' + this.route_query);
        })
      }
      else {
        await predmeti.arhivirajPredmet(this.route_query, this.unos_predmeta.datum_arhiviranja).then((resp) => {
          this.fetching = false;
          this.archive_popup = false,
            this.$router.push('/archived-case/' + this.route_query);
        })
      }
    },
    addPerson() {
      this.all_fiz_prav = this.all_fiz_prav.filter((fiz) => fiz.link != this.temp_osoba.UID);
      this.unos_predmeta.vezane_osobe.stranke.results_final.push(this.temp_osoba);
      if (this.$store.state.ime_predmeta.ime_stranke == "" && !this.is_edit) {
        this.$store.state.ime_predmeta.ime_stranke = this.temp_osoba.name;
      }
      this.postojeca_stranka_protustranka = false;
    },
    removeFromQuick() {
      this.$refs.quickNadleznaTijela.$data.add_nadlezno_tijelo = [];
    },
    removeExisting() {
      this.$refs.nadleznaTijela.results_final.uid = "";
      this.$refs.nadleznaTijela.results_final.name = "";
    },
    addToAutocomplete(osoba, temp_osoba_status, tip) {
      let temp_obj = {
        name: osoba.value,
        status_ID: temp_osoba_status,
        UID: osoba.link,
        is_fiz: osoba.is_fiz,
        connection_status: osoba.connection_status,
      };
      switch (tip) {
        case 'Stranka':
          if (!this.unos_predmeta.vezane_osobe.stranke.results_final.find(os => os.UID == temp_obj.UID)) {
            if (temp_obj.connection_status == 1) {
              this.postojeci_dialog_text = this.$t("forms.case.postojeci_dialog_text",{name:temp_obj.name});
              this.temp_osoba = temp_obj;
              this.postojeca_stranka_protustranka = true;
            }
            else {
              this.all_fiz_prav = this.all_fiz_prav.filter((fiz) => fiz.link != temp_obj.UID);
              this.unos_predmeta.vezane_osobe.stranke.results_final.push(temp_obj);
              if (this.$store.state.ime_predmeta.ime_stranke == "" && !this.is_edit) {
                this.$store.state.ime_predmeta.ime_stranke = osoba.value;
              }
            }
          }
          break;
        case 'Protustranka':
          if (!this.unos_predmeta.vezane_osobe.protustranke.results_final.find(os => os.UID == temp_obj.UID)) {
            this.all_fiz_prav = this.all_fiz_prav.filter((fiz) => fiz.link != temp_obj.UID);
            this.unos_predmeta.vezane_osobe.protustranke.results_final.push(temp_obj);
            if (this.$store.state.ime_predmeta.ime_protustranke == "") {
              this.$store.state.ime_predmeta.ime_protustranke = osoba.value;
            }
          }
          break;
        case 'Drugi_sudionici':
          if (!this.unos_predmeta.vezane_osobe.drugi_sudionici.results_final.find(os => os.UID == temp_obj.UID)) {
            this.all_fiz_prav = this.all_fiz_prav.filter((fiz) => fiz.link != temp_obj.UID);
            this.unos_predmeta.vezane_osobe.drugi_sudionici.results_final.push(temp_obj);
          }
          break;
        case 'Nadležno_tijelo':
          if (!this.$refs.nadleznaTijela.results_final.UID != temp_obj.UID) {
            this.$refs.nadleznaTijela.results_final.uid = temp_obj.UID;
            this.$refs.nadleznaTijela.results_final.name = temp_obj.name;
          }
          break;
        case 'Pravno_tijelo':
          if (!this.unos_predmeta.vezane_osobe.leg_bodies.results_final.find(os => os.UID == temp_obj.UID)) {
            this.legal_bodies = this.legal_bodies.filter((fiz) => fiz.link != temp_obj.UID);
            this.unos_predmeta.vezane_osobe.leg_bodies.results_final.push(temp_obj);
          }
          break;
        default:
          break;
      }
    },
    assignToMe() {
      let found_nositelj = this.$refs.clanTima.$data.results_final.some((el) => el.status_ID == 2)
      if (!this.$refs.clanTima.$data.results_final.find(el => el.UID == this.$store.state.logged_in_user.uid)) {
        this.$refs.clanTima.$data.results_final.push({
          'UID': this.$store.state.logged_in_user.uid,
          'is_fiz': true,
          'name': this.$store.state.logged_in_user.ime + ' ' + this.$store.state.logged_in_user.prezime,
          'status_ID': !found_nositelj ? 2 : 1
        });
        this.$refs.clanTima.unableNositelj();
        this.tim = this.tim.filter((fiz) => fiz.link != this.$store.state.logged_in_user.uid);
      }
    },
    async sequence_start() {
      this.validate()
    },

    async validate() {
      this.fetching = true;
      this.clearElements();
      // console.log(this.popis_broja_predmeta);
      //check ako postoji predmet u bazi i je li prazan
      if (this.unos_predmeta.broj_predmeta == "") {
        this.errors.push(this.$t('forms.case.errors.err1'))
        this.invalid_elements.broj_predmeta = true;
      }
      if (this.popis_broja_predmeta.filter(o=>o.year == this.unos_predmeta.sort_year && o.no == this.unos_predmeta.sort_no).length>0) {
        if (!this.is_edit || (this.is_edit && (this.unos_predmeta.sort_year != this.predmet_all.sort_year || this.unos_predmeta.sort_no != this.predmet_all.sort_no))) {
          this.errors.push(this.$t('forms.case.errors.err2',{w1:this.unos_predmeta.sort_year,w2:this.unos_predmeta.sort_no}))
          this.invalid_elements.broj_predmeta = true;
        }
      }
      //check stranke
      let stranke_check = this.unos_predmeta.vezane_osobe.stranke.results_final
      let quick_stranke_check = this.unos_predmeta.vezane_osobe.quickStranke
      if (stranke_check.length == 0 && quick_stranke_check.add_stranka == 0) {
        this.errors.push(this.$t('forms.case.errors.err3'));
        this.invalid_elements.stranka = true;
      }
      else {
        for (let i = 0; i < stranke_check.length; i++) {
          if (stranke_check[i].status_ID == null) {
            if (stranke_check[i].is_fiz) {
              this.errors.push(this.$t('forms.case.errors.err4',{w1:stranke_check[i].name,w2:stranke_check[i].surname}));
            } else {
              this.errors.push(this.$t('forms.case.errors.err5',{w1:stranke_check[i].legal_name}));
            }
            this.invalid_elements.stranka = true;
          }
        }
      }

      //check protustranke
      let protustranke_check = this.unos_predmeta.vezane_osobe.protustranke.results_final;
      for (let i = 0; i < protustranke_check.length; i++) {
        if (protustranke_check[i].status_ID == null) {
          if (protustranke_check[i].is_fiz) {
            this.errors.push(this.$t('forms.case.errors.err6',{w1:protustranke_check[i].name,w2:protustranke_check[i].surname}));
          } else {
            this.errors.push(this.$t('forms.case.errors.err7',{w1:protustranke_check[i].legal_name}));
          }
          this.invalid_elements.protustranka = true;
        }
      }

      //check ime predmeta
      if (this.unos_predmeta.ime_predmeta.value == "") {
        this.errors.push(this.$t('forms.case.errors.err8'))
        this.invalid_elements.ime_predmeta = true;
      }

      //check clan tima
      let clan_check = this.unos_predmeta.vezane_osobe.leg_tim.results_final;
      let nositelj_found = false;
      let clan_bez_statusa_found = false;
      for (let i = 0; i < clan_check.length; i++) {
        if (clan_check[i].status_ID == 2) {
          nositelj_found = true;
        }
        if (clan_check[i].status_ID == 0) {
          clan_bez_statusa_found = true;
        }
      }
      if (!nositelj_found) {
        this.errors.push(this.$t('forms.case.errors.err9'));
        this.invalid_elements.clan_tima = true;
      }
      if (clan_bez_statusa_found) {
        this.errors.push(this.$t('forms.case.errors.err10'));
        this.invalid_elements.clan_tima = true;
      }
      //korisnik moze upisati , ili . kao decimalnu vrijednost
      this.unos_predmeta.VPS.input_value = this.unos_predmeta.VPS.input_value != null && this.unos_predmeta.VPS.input_value != 0 ? this.unos_predmeta.VPS.input_value.toString().replace(",", ".") : null;
      if (isNaN(this.unos_predmeta.VPS.input_value)) {
        this.errors.push(this.$t('forms.case.errors.err11'));
        this.invalid_elements.VPS = true;
      }
      // console.log(this.unos_predmeta);
      //ako nema gresaka kreiraj/update-aj predmet
      //odkomentirati prije unošenja u bazu
      if (this.errors.length == 0) {
        this.is_waiting_on_insert = true;
        let temp_nadlezno = this.unos_predmeta.nadlezno_tijelo.results_final;
        this.unos_predmeta.nadlezno_tijelo.results_final = temp_nadlezno.uid != "" ? [temp_nadlezno] : [];
        if (this.is_edit) {
          this.accessToken = this.$store.state.aToken
          predmet.updatePredmet(this.unos_predmeta, this.accessToken, this.route_query, this.$store.state.logged_in_user.uid).then(async (resp) => {
            this.fetching = false;
            this.is_waiting_on_insert = false;
            await clearCaseData();
            this.continueGoBack();
          }).catch((e) => {
            this.is_waiting_on_insert = false;
            this.fetching = false;
            this.unos_predmeta.nadlezno_tijelo.results_final = temp_nadlezno;

            // Handle error response from server
            const errorMessage = (e.response && e.response.data && e.response.data.message) || this.$t('forms.case.errors.update_failed');
            this.errors.push(errorMessage);
            console.error('[CASE_UPDATE_ERROR]', (e.response && e.response.data) || e);
          });
        } else {
          this.kreirajPredmet(temp_nadlezno);
        }
        // console.log(this.errors);
      }
      else {
        this.fetching = false;
      }

    },
    clearElements() {
      this.errors = [];
      this.invalid_elements = {
        broj_predmeta: false,
        stranka: false,
        protustranka: false,
        ime_predmeta: false,
        clan_tima: false,
        VPS: false,
      }
    },
    async kreirajPredmet(temp_nadlezno) {
      this.accessToken = this.$store.state.aToken
      console.log(this.unos_predmeta);
      predmet
        .addPredmet(this.unos_predmeta, this.accessToken, this.$store.state.logged_in_user.uid)
        .then(async (resp) => {
          this.fetching = false;
          this.is_waiting_on_insert = false;
          this.$router.push(resp.data.case_url);
        }).catch((err) => {
          this.fetching = false;
          this.is_waiting_on_insert = false;
          this.unos_predmeta.nadlezno_tijelo.results_final = temp_nadlezno;

          // Handle error response from server
          const errorMessage = (err.response && err.response.data && err.response.data.message) || this.$t('forms.case.errors.creation_failed');
          const rollbackStatus = err.response && err.response.data && err.response.data.rollback;

          // Add error to the errors list for display
          this.errors.push(errorMessage);

          // Log detailed error for debugging
          console.error('[CASE_CREATION_ERROR]', {
            message: errorMessage,
            rollback: rollbackStatus,
            fullError: (err.response && err.response.data) || err
          });
        });
    },

    async connectExitstingData() {
      //get case with uid
      await predmet.getSingle(this.route_query, this.$store.state.logged_in_user.uid).then((resp) => {

        let all_together = resp.data.all_info_predmet.predmet_info
        let predmet_info = all_together;
        this.predmet_all = all_together;

        // this.unos_predmeta.broj_predmeta = predmet_info.broj_predmeta;
        this.unos_predmeta.sort_year = predmet_info.sort_year;
        this.unos_predmeta.sort_no = predmet_info.sort_no;
        this.unos_predmeta.case_type = predmet_info.predmet_type;
        this.$refs.fazaPredmeta.$data.ID = predmet_info.faza_postupka.id_status;
        this.$refs.imePredmeta.$data.value = predmet_info.ime_predmeta;
        this.$refs.opisPredmeta.$data.value = predmet_info.opis_predmeta;
        this.$refs.vrstaPostupka.$data.ID = predmet_info.id_vrsta_postupka;
        this.$refs.sudskiBroj.$data.value = predmet_info.posl_br;
        this.$refs.valuta.$data.drop_value = predmet_info.uid_currency
        this.$refs.valuta.$data.input_value = predmet_info.VPS == null ? 0 : predmet_info.VPS
        this.unos_predmeta.datum_kreiranja = predmet_info.datum_pocetka != "" ? moment(predmet_info.datum_pocetka).format("yyyy-MM-DD") : "";
        this.unos_predmeta.datum_arhiviranja = predmet_info.datum_arhiviranja != "" && predmet_info.datum_arhiviranja != null ? moment(predmet_info.datum_arhiviranja).format("yyyy-MM-DD") : "";
        this.unos_predmeta.datum_unistavanja = predmet_info.datum_unistenja != "" && predmet_info.datum_unistenja != null ? moment(predmet_info.datum_unistenja).format("yyyy-MM-DD") : "";
        if (predmet_info.is_archived) {
          this.archived_predmet = true;
          this.archive_button_text =  this.$t('forms.case.archive_button_text2');
          this.popup_button_text = this.$t('forms.case.popup_button_text2');
          this.popup_text = this.$t('forms.case.popup_text2');
        }
        if (predmet_info.is_destroyed) {
          this.destroyed_predmet = true;
        }
        //get all phisycal entities
        predmet_info.connect_fiz_stranka.forEach((p) => {
          let temp_os = this.all_fiz_prav.find((fiz) => fiz.link == p.fizicka_osoba.uid);
          let temp_obj = {
            name: p.fizicka_osoba.ime + " " + p.fizicka_osoba.prezime,
            status_ID: p.oznake_status.id_status,
            UID: p.fizicka_osoba.uid,
            is_fiz: true,
            connection_status: temp_os.connection_status,
          };
          this.all_fiz_prav = this.all_fiz_prav.filter((fiz) => fiz.link != temp_obj.UID);
          this.unos_predmeta.vezane_osobe.stranke.results_final.push(temp_obj);
        });
        predmet_info.prav_connect_stranka.forEach((p) => {
          let temp_os = this.all_fiz_prav.find((fiz) => fiz.link == p.pravna_osoba.uid);
          let temp_obj = {
            name: p.pravna_osoba.ime,
            status_ID: p.oznake_status.id_status,
            UID: p.pravna_osoba.uid,
            is_fiz: false,
            connection_status: temp_os.connection_status,
          };
          this.all_fiz_prav = this.all_fiz_prav.filter((fiz) => fiz.link != temp_obj.UID);
          this.unos_predmeta.vezane_osobe.stranke.results_final.push(temp_obj);
        });
        //connect ostali fizicke
        predmet_info.connect_fiz_ostali.forEach((p) => {
          let temp_os = this.all_fiz_prav.find((fiz) => fiz.link == p.fizicka_osoba.uid);
          console.log(temp_os);
          let temp_obj = {
            name: p.fizicka_osoba.ime + " " + p.fizicka_osoba.prezime,
            status_ID: p.oznake_status.id_status,
            UID: p.fizicka_osoba.uid,
            is_fiz: true,
            connection_status: temp_os.connection_status,
          };
          this.all_fiz_prav = this.all_fiz_prav.filter((fiz) => fiz.link != temp_obj.UID);
          this.unos_predmeta.vezane_osobe.drugi_sudionici.results_final.push(temp_obj);
        });
        //connect ostali pravni
        predmet_info.prav_connect_ostali.forEach((p) => {
          let temp_os = this.all_fiz_prav.find((fiz) => fiz.link == p.pravna_osoba.uid);
          let temp_obj = {
            name: p.pravna_osoba.ime,
            status_ID: p.oznake_status.id_status,
            UID: p.pravna_osoba.uid,
            is_fiz: false,
            connection_status: temp_os.connection_status,
          };
          this.all_fiz_prav = this.all_fiz_prav.filter((fiz) => fiz.link != temp_obj.UID);
          this.unos_predmeta.vezane_osobe.drugi_sudionici.results_final.push(temp_obj);
        });

        predmet_info.connect_fiz_protustranka.forEach((p) => {
          let temp_os = this.all_fiz_prav.find((fiz) => fiz.link == p.fizicka_osoba.uid);
          let temp_obj = {
            name: p.fizicka_osoba.ime + " " + p.fizicka_osoba.prezime,
            status_ID: p.oznake_status.id_status,
            UID: p.fizicka_osoba.uid,
            is_fiz: true,
            connection_status: temp_os.connection_status,
          };
          this.all_fiz_prav = this.all_fiz_prav.filter((fiz) => fiz.link != temp_obj.UID);
          this.unos_predmeta.vezane_osobe.protustranke.results_final.push(temp_obj);
        });
        predmet_info.prav_connect_protustranka.forEach((p) => {
          let temp_os = this.all_fiz_prav.find((fiz) => fiz.link == p.pravna_osoba.uid);
          let temp_obj = {
            name: p.pravna_osoba.ime,
            status_ID: p.oznake_status.id_status,
            UID: p.pravna_osoba.uid,
            is_fiz: false,
            connection_status: temp_os.connection_status,
          };
          this.all_fiz_prav = this.all_fiz_prav.filter((fiz) => fiz.link != temp_obj.UID);
          this.unos_predmeta.vezane_osobe.protustranke.results_final.push(temp_obj);
        });
        let no_end_date_list = predmet_info.predmet_odvjetnik_connector.filter((p)=>{return p.end_date == null})
        no_end_date_list.forEach((p) => {
          let temp_obj = {
            name: p.odvjetnik.ime + " " + p.odvjetnik.prezime,
            status_ID: p.status_odvjetnik_predmet.id_status,
            UID: p.odvjetnik.uid,
            is_fiz: true,
          };
          this.tim = this.tim.filter((fiz) => fiz.link != temp_obj.UID);
          this.$refs.clanTima.unableNositelj();
          this.unos_predmeta.vezane_osobe.leg_tim.results_final.push(temp_obj);
        });
        predmet_info.connect_institucija_predmet.forEach((p) => {
          let temp_obj = {
            name: p.institucija.naziv,
            uid: p.institucija.uid,
            is_fiz: false,
          };
          this.unos_predmeta.nadlezno_tijelo.results_final = temp_obj;
        });
        predmet_info.connect_sluzbena_osoba.forEach((p) => {
          let temp_obj = {
            name: p.sluzbena_osoba.ime + " " + p.sluzbena_osoba.prezime,
            status_ID: p.sluzbena_uloga.id_uloga,
            UID: p.sluzbena_osoba.uid,
            is_fiz: true,
          };
          this.unos_predmeta.vezane_osobe.leg_bodies.results_final.push(temp_obj);
        });
        this.fetching = false;
      });
    },
  },
  async created() {
    this.fetching = true,
      this.accessToken = this.$store.state.aToken 

    await financial.getAllCurrency().then((resp) => {
      // console.log(resp)
    })

    await osobe.getAllStatusi().then((resp) => {
      this.statusi.stranka = resp.data.stranka_protu_statusi;
      this.statusi.protustranka = resp.data.stranka_protu_statusi;
      this.statusi.leg_tim = resp.data.leg_tim_status;
      this.$refs.quickStranka.$data.status_ID = "25";
      this.$refs.quickProtustranka.$data.status_ID = "22"
      this.$refs.quickDrugiSudionici.$data.status_ID = "30"
      // console.log(this.statusi.leg_tim);
    });
    await predmeti.getAllBrojevi().then((resp) => {
      // this.unos_predmeta.broj_predmeta = resp.data.predlozak_broj_predmeta;
      console.log(resp.data);
      this.unos_predmeta.sort_year = resp.data.predlozak_broj_predmeta.split("-")[0];
      this.unos_predmeta.sort_no = resp.data.predlozak_broj_predmeta.split("-")[1];

      for (let i = 0; i < resp.data.popis_broja_predmeta.length; i++) {
        this.popis_broja_predmeta.push({year: resp.data.popis_broja_predmeta[i].sort_year, no: resp.data.popis_broja_predmeta[i].sort_no});
      }
    });
    await predmeti.getAllPostupci().then((resp) => {
      this.postupak = resp.data.vrste_postupka;
      this.$refs.vrstaPostupka.$data.ID = 23;
    });
    await predmeti.getAllType().then((resp) => {
      console.log(resp)
      this.all_case_type = resp.data;

    });
    await institucije.getAllInstitucijeShort().then((resp) => {
      this.all_institucije = resp.data
      this.all_institucije_copy = [...this.all_institucije];
    });
    await osobe.getAllFizLeg().then((resp) => {
      this.all_fiz_prav = resp.data.all_osobe;
      this.all_fiz_prav_copy = [...this.all_fiz_prav];
      this.tim = resp.data.all_pravnici;
    });

    await osobe.get_all_legal_body_short().then((resp) => {
      this.legal_bodies = resp.data;
      this.legal_bodies_copy = [...this.legal_bodies];
      // console.log(this.legal_bodies);
    });

    await statusi.getLegBodyStatusi().then((resp) => {
      console.log(resp.data)
      this.statusi.leg_body = resp.data.oznake_status;
    });
    await predmeti.getAllPhases().then((resp) => {
      // console.log(resp.data);
      this.faze = resp.data.faze_postupka
      this.$refs.fazaPredmeta.$data.ID = 8;
    })

    await financije.getAllCurrency().then((resp) => {
      // console.log(resp.data)
      this.valute = resp.data;
    })
    this.unos_predmeta.datum_kreiranja = moment(Date.now()).format("yyyy-MM-DD");
    //check the url params if we are on edit
    this.route_query = this.$router.history.current.params.uid;
    if (this.route_query != undefined) {
      this.is_edit = true;

      this.isNumberEditDisabled = !await permissioner.is_user_admin();

      this.connectExitstingData();
      this.create_edit_button =  this.$t('forms.case.create_edit_button2');
      this.title_edit_new =  this.$t('forms.case.title_edit_new2');
    }
    else {
      this.fetching = false;
    }
  },
  computed:{
    dateText(){
      return moment(this.unos_predmeta.datum_arhiviranja).format('DD.MM.yyyy');
    },
    dateTextDestroyed(){
      return moment(this.unos_predmeta.datum_unistavanja).format('DD.MM.yyyy');
    },
    inhouseLimit : function()
    {
      return parseInt(this.unos_predmeta.case_type) > 1;
    }
  },
  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-autocomplete": formAutocomplete,
    "button-person-quick": buttonPersonQuick,
    "form-currency-input": formCurrencyInput,
    "form-autocomplete-single": formAutocompleteSingle,
    InvalidElementsList,
    DataLoader
  },

  mounted() {
    this.$store.state.ime_predmeta.broj_predmeta = "";
    this.$store.state.ime_predmeta.ime_stranke = "";
    this.$store.state.ime_predmeta.ime_protustranke = "";

    document.body.classList.add("new-entry");
    // this.unos_predmeta.sort_year = this.$refs.sortYear.$data;
    // this.unos_predmeta.sort_no = this.$refs.sortNo.$data;
    // this.unos_predmeta.broj_predmeta = this.$refs.brojPredmeta.$data;
    this.unos_predmeta.faza = this.$refs.fazaPredmeta.$data;
    this.unos_predmeta.ime_predmeta = this.$refs.imePredmeta.$data;
    this.unos_predmeta.opis_predmeta = this.$refs.opisPredmeta.$data;
    this.unos_predmeta.vrsta_postupka = this.$refs.vrstaPostupka.$data;
    this.unos_predmeta.nadlezno_tijelo = this.$refs.nadleznaTijela.$data;
    this.unos_predmeta.sudski_broj = this.$refs.sudskiBroj.$data;
    this.unos_predmeta.vezane_osobe.leg_tim = this.$refs.clanTima.$data;
    this.unos_predmeta.vezane_osobe.leg_bodies = this.$refs.pravnoTijelo.$data;
    this.unos_predmeta.vezane_osobe.stranke = this.$refs.stranka.$data;
    this.unos_predmeta.vezane_osobe.drugi_sudionici = this.$refs.drugi_sudionici.$data;
    this.unos_predmeta.vezane_osobe.quickStranke =
      this.$refs.quickStranka.$data;
    this.unos_predmeta.vezane_osobe.protustranke =
      this.$refs.protustranka.$data;
    this.unos_predmeta.vezane_osobe.quickProtustranke =
      this.$refs.quickProtustranka.$data;
    this.unos_predmeta.vezane_osobe.quickNadleznaTijela =
      this.$refs.quickNadleznaTijela.$data;
    this.unos_predmeta.vezane_osobe.quickPravnaTijela =
      this.$refs.quickPravnoTijelo.$data;
    this.unos_predmeta.vezane_osobe.quickDrugiSudionici =
      this.$refs.quickDrugiSudionici.$data;
    this.unos_predmeta.VPS = this.$refs.valuta.$data
    // this.$store.state.ime_predmeta.broj_predmeta = this.unos_predmeta.broj_predmeta.value;

    //close anim
    $(".entry-exit").hover(
      function () {
        gsap.to($(this).find("img"), 0.3, {
          rotation: 180,
          transformOrigin: "center",
        });
      },
      function () {
        gsap.to($(this).find("img"), 0.5, {
          rotation: -180,
          transformOrigin: "center",
        });
      }
    );
  },
  updated() {
    //stavljanje broja predmeta u store
    // this.$store.state.ime_predmeta.broj_predmeta = this.prijedlog_br_predmet; provjeri zašto ne radi
    this.$store.state.ime_predmeta.broj_predmeta = this.unos_predmeta.broj_predmeta;
    // console.log(this.$store.state.ime_predmeta);
  },
  destroyed() {
    document.body.classList.remove("new-entry");
    $(".entry-exit").off();
  },
};
</script>
